module.exports = __webpack_public_path__ + "img/ring_r_skip_1_0.cde1f8dd.png";